import { render } from "./myResell.vue?vue&type=template&id=af488828"
import script from "./myResell.vue?vue&type=script&lang=js"
export * from "./myResell.vue?vue&type=script&lang=js"

import "./myResell.vue?vue&type=style&index=0&id=af488828&lang=scss"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__